import React from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import { cloneDeep, isEmpty } from 'lodash';
import '../SystemMasters.css';

export default function DropdownCard({
  item,
  index,
  handleChanged,
  renderTooltipAddValue,
  addValueForLabel,
  renderTooltipActiveInactive,
  activeInactiveClicked,
  renderTooltipDelete,
  renderTooltipAddOption,
  handleDelete,
  handleValueChanged,
  openList,
  setOpenList,
  // handleCheckboxCA,
  // onDropSelectionChange,
  isUniqueId,
}) {
  const handleOpenLabelOption = (i) => {
    let data = cloneDeep(openList);

    if (data.includes(i)) {
      const indexOf = data.indexOf(i);
      if (indexOf > -1) {
        data.splice(indexOf, 1);
      }
    } else {
      data = [i, ...data];
    }
    setOpenList(data);
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className="card listing-card mx-12 p-2 mb-2 flex-fill" key={index}>
        <div className="dropdown-container">
          <div className="input-container">
            <div className="input-group form-floating-label fixed-label">
              <input
                key={index}
                name="freeLabel"
                autoFocus={!item?._id}
                value={item?.keyName ? item?.keyName : ''}
                placeholder="Enter Label"
                type="text"
                onChange={(e) => handleChanged(e, index)}
                className="form-control"
                maxLength="50"
              />
              <label className="asterisk-req">
                Label<span>*</span>
              </label>
            </div>
            {item?.isEmpty && (item?.keyName === null || item?.keyName === '') && <label className="text-danger m-0 p-1">Label is required.</label>}
          </div>
          <div className="input-action d-flex">
            {item?._id !== '' && (
              <>
                <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipActiveInactive}>
                  <button
                    type="button"
                    className=" mr-0"
                    onClick={() => activeInactiveClicked(item?._id)}
                    id={item?._id}
                    // title={item?.isActive ? "Active" : "Inactive"}
                    aria-label={item?.isActive ? 'Active' : 'Inactive'}
                  >
                    <span className={item?.isActive ? 'icon-active' : 'icon-inactive'} />
                  </button>
                </OverlayTrigger>

                <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipAddValue}>
                  <button type="button" className=" mr-0" onClick={() => addValueForLabel(item?._id, index)} id={item?._id} aria-label="Add">
                    <span className="icon-add" />
                  </button>
                </OverlayTrigger>

                <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipAddOption}>
                  <button
                    type="button"
                    className="position-relative mr-0"
                    onClick={() => {
                      handleOpenLabelOption(index);
                    }}
                  >
                    {openList.includes(index) ? (
                      <span className="icon-new-down-arrow-icon icon-dropdown" />
                    ) : (
                      <span className="icon-new-down-arrow-icon transform-class" />
                    )}
                  </button>
                </OverlayTrigger>
              </>
            )}

            <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipDelete}>
              <button
                type="button"
                className=" mr-0"
                onClick={() => {
                  handleDelete(item?._id ? item?._id : index);
                }}
                // title="delete"
                aria-label="delete"
              >
                <span className="icon-delete" />
              </button>
            </OverlayTrigger>
          </div>
        </div>
        {!isEmpty(isUniqueId) && isUniqueId?.includes(index) && <label className="text-danger m-0 p-1">This entery already Exist</label>}
        {/* <div className="product-type-container custom-multiselect">
          <CommonMultiSelect
            label="Product Type"
            required
            onChange={(e) => onDropSelectionChange(e, index)}
            selectedValue={item?.productType}
            optionList={item?._id ? pcTypeList : pcTypeList?.filter((e) => e?.isActive) || []}
            selectLabel="name"
            selectValue="_id"
            disable={item?._id}
          />
          {item?.isEmpty && item?.productType?.length === 0 && <label className="text-danger m-0 p-1">Product type is required.</label>}
        </div> */}

        {!isEmpty(item?.options || []) ? (
          item?.options?.map((eleValue, indexValue) => {
            return (
              <div key={item?._id} className={openList.includes(index) ? 'dropdown-items show' : 'dropdown-items '}>
                <div className="freetext-container mt-2 mx-0">
                  <div className="input-container">
                    <div className="input-group form-floating-label fixed-label">
                      <input
                        key={item?._id}
                        name="freeLabel"
                        // eslint-disable-next-line jsx-a11y/no-autofocus
                        autoFocus={!eleValue._id}
                        value={eleValue.keyName ? eleValue.keyName : ''}
                        placeholder="Enter Value"
                        type="text"
                        onChange={(e) => handleValueChanged(e, indexValue, index)}
                        className="form-control"
                        maxLength="50"
                      />
                      <label htmlFor="value" className="asterisk-req">
                        Value {indexValue + 1}
                        <span>*</span>
                      </label>
                      {item?.isEmpty && (item?.keyName === null || item?.keyName === '') && <label className="text-danger m-0 p-1">Value is required.</label>}
                    </div>
                  </div>
                  <div className="input-action d-flex">
                    {eleValue._id !== '' && (
                      <OverlayTrigger
                        placement="auto"
                        delay={{
                          show: 250,
                          hide: 400,
                        }}
                        overlay={renderTooltipActiveInactive}
                      >
                        <button type="button" className=" mr-0" onClick={() => activeInactiveClicked(eleValue._id)} id={eleValue._id}>
                          <span className={eleValue.isActive ? 'icon-active' : 'icon-inactive'} />
                        </button>
                      </OverlayTrigger>
                    )}

                    <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipDelete}>
                      <button
                        className=" mr-0"
                        type="button"
                        title="Delete"
                        aria-label="Delete"
                        onClick={() => {
                          handleDelete(eleValue._id ? eleValue._id : indexValue, index);
                        }}
                      >
                        <span className="icon-delete f-20" />
                      </button>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className={openList?.includes(index) ? 'dropdown-items show' : 'dropdown-items '}>
            <p className="mt-3 mb-0 text-center">No Options Found.</p>
          </div>
        )}
      </div>
    </div>
  );
}
